import { twoFactorClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

// Staff session (cookie) via better-auth at /api/auth on the same origin.
export const authClient = createAuthClient({ plugins: [twoFactorClient()] });
